import type { PaginationParams, PickActions } from '@recruitee/ngrx';
import { createEntityCollectionStore, getEntityCollectionActions } from '@recruitee/ngrx';
import type { TemplateAssignedOffer } from '@recruitee/workflow-templates-types';

const { actions, reducer, selectors, namespace } =
  createEntityCollectionStore<TemplateAssignedOffer>()('TemplateAssignedOffer', {
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, ({ id }: { id: number }) => id);
      return {
        fetchPaginatedCollection: (
          state,
          payload: { scope: string; params: PaginationParams & { q: string | null; id: number } },
        ) => defaultActions.fetchPaginatedCollection(state, payload),
      };
    },
  });

const TemplateAssignedOfferActions: PickActions<typeof actions, 'fetchPaginatedCollection'> =
  actions;

export {
  TemplateAssignedOfferActions,
  reducer as TemplateAssignedOfferReducer,
  selectors as TemplateAssignedOfferSelectors,
  namespace as TemplateAssignedOfferNamespace,
};
